import React, { useContext } from 'react';

import { initialSentenceState } from '../../Sentence/helpers/dummyElement';
import { SentenceAction } from '../../Sentence/hooks/reducer';

type SentenceContextT = {
    sentence: SentenceQueryT;
    dispatchSentence: React.Dispatch<SentenceAction>;
    isLoadingModel: boolean;
    setIsLoadingModel: React.Dispatch<React.SetStateAction<boolean>>;
};
const SentenceContext = React.createContext<SentenceContextT>({
    sentence: initialSentenceState,
    dispatchSentence: () => {},
    isLoadingModel: false,
    setIsLoadingModel: () => {},
});

export const useSentenceContext = () => useContext(SentenceContext);

export default SentenceContext;
